import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Card, CardContent } from "@/components/ui/card";

/** A card with a spinner, while a page's data loads. */
export function LoadingCard() {
  const { t } = useTranslation();
  return (
    <Card>
      <CardContent className="flex justify-center py-12">
        <Loader2 className="text-muted h-6 w-6 animate-spin" aria-label={t("common.loading")} />
      </CardContent>
    </Card>
  );
}

interface LoadErrorCardProps {
  /** What failed, as a sentence in the dashboard's language: "De tools konden niet geladen worden." */
  message: string;
  onRetry: () => void;
}

/** A card saying what could not load, with a way to try again. */
export function LoadErrorCard({ message, onRetry }: LoadErrorCardProps) {
  const { t } = useTranslation();
  return (
    <Card>
      <CardContent className="py-8 text-center">
        <p className="text-muted text-sm">
          {message}{" "}
          <button type="button" onClick={onRetry} className="underline">
            {t("common.tryAgain")}
          </button>
        </p>
      </CardContent>
    </Card>
  );
}
